<template>
  <div class="prove-verify-wrapper">
    <el-form
      ref="formDate"
      :model="formDate"
      :rules="editRules"
      :label-width="`${adaptationVars.formLabelWidth}px`"
      class="demo-ruleForm"
      label-position="left"
    >
      <el-row>
        <el-col :span="12">
          <el-form-item label="数据承诺" prop="commitment">
            <el-input v-model="formDate.commitment" placeholder="请输入承诺"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="数据证明" prop="proof">
            <el-input v-model="formDate.proof" placeholder="请输入证明"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="验证结果" prop="result">
            <el-input v-model="formDate.result" disabled></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item>
            <el-button type="primary" @click="handleProve()">确定</el-button>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
  </div>
</template>

<script>
import adaptation from '@/mixins/adaptation'
export default {
  name: 'Index',
  mixins: [adaptation],
  adaptationVarsDefine: {
    formLabelWidth: 100
  },
  data() {
    return {
      formDate: {
        commitment: '',
        proof: '',
        result: ''
      },
      orgOtion: [],
      editRules: {
        commitment: [{ required: true, message: '请输入承诺', trigger: 'blur' }],
        proof: [{ required: true, message: '请输入证明', trigger: 'blur' }]
      },
      adaptationVars: {
        formLabelWidth: 100
      }
    }
  },
  mounted() {
    this.formDate.opening = localStorage.getItem('opening')
  },
  methods: {
    handleProve() {
      this.$refs.formDate.validate().then(valid => {
        if (valid) {
          this.$apis.bulletproofs.proveVerify(this.formDate).then(res => {
            if (res) {
              this.formDate.result = res.data
              if (res.data) {
                this.$message.success('验证成功!')
              } else {
                this.$message.error('验证失败!')
              }
            }
          })
        }
      })
    }
  }
}
</script>

<style scoped lang="scss">
.prove-verify-wrapper {
  .el-row {
    margin: 0 calc(0px - var(--base-size-16));

    .el-col {
      padding: 0 var(--base-size-16);
    }
  }
}

</style>
